module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="sortable" ' +
((__t = ( data.header.title ? 'title="' + data.header.title + '" data-toggle="tooltip"' : '')) == null ? '' : __t) +
'>\n    ' +
((__t = ( data.name )) == null ? '' : __t) +
'\n';
 if (data.sortOptions && data.sortOptions.active && data.sortOptions.active === "-1") { ;
__p += '\n    <i class="fas fa-sort-down"></i>\n';
 } else if (data.sortOptions && data.sortOptions.active && data.sortOptions.active === "1") { ;
__p += '\n    <i class="fas fa-sort-up"></i>\n';
 } else { ;
__p += '\n    <i class="fas fa-sort"></i>\n';
 } ;
__p += '\n</div>';
return __p
}